import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { currentLanguage, changeLanguage } = useLanguage();

  const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ];

  return (
    <div className={`relative group ${className}`}>
      <button className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-black hover:bg-gray-800 border border-gray-700 transition-colors">
        <Globe size={16} className="text-primary" />
        <span className="text-sm font-medium text-white">
          {languages.find(lang => lang.code === currentLanguage)?.flag}
        </span>
      </button>
      
      {/* Dropdown */}
      <div className="absolute top-full left-0 mt-2 w-40 bg-black border border-gray-700 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((language) => (
          <button
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            className={`w-full px-3 py-2 text-left text-sm hover:bg-gray-700 first:rounded-t-lg last:rounded-b-lg transition-colors ${
              currentLanguage === language.code 
                ? 'text-primary bg-gray-700' 
                : 'text-white'
            }`}
          >
            <span className="mr-2">{language.flag}</span>
            {language.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;